import React, { useRef, useEffect, useState } from 'react';
import { skills } from '../../data/portfolioData';

const SkillBar = ({ name, level, colorClass }) => {
  const [width, setWidth] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => setWidth(level), 200);
      }
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [level]);

  return (
    <div className="skill-item" ref={ref}>
      <div className="skill-header">
        <span className="skill-name">{name}</span>
        <span className="skill-pct">{level}%</span>
      </div>
      <div className="skill-track">
        <div className={`skill-bar ${colorClass}`} style={{ width: `${width}%` }} />
      </div>
    </div>
  );
};

const SkillsSection = () => (
  <section className="skills-section" id="skills">
    <div className="section-header">
      <span className="section-meta">My Specialty</span>
      <h2 className="section-title">My Skills</h2>
    </div>
    <p className="skills-intro">
      I am proficient in a diverse set of technologies, including <strong>Node.js, PHP, JavaScript
      (both vanilla and frameworks like Angular and React)</strong>, and have hands-on experience
      with cloud services such as AWS. My expertise extends across the full stack, allowing me to
      design and implement robust and scalable solutions.
    </p>
    <div className="skills-grid">
      {skills.map(s => <SkillBar key={s.id} {...s} />)}
    </div>
  </section>
);

export default SkillsSection;
